import Header from '../Header/Header'
import Constants from '../../../app/utils/constants'
import fintechbg from '../../../assets/images/industrypage/fintechbg.webp'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const FintechHeroSection = () => {
  const { heading } = Constants.fintechHeroSection

  return (
    <CommonHeroSection
      wrapperClassName="relative h-[65vh] w-full  md:h-[85vh] lg:h-[95vh] overflow-hidden pb-12 md:pb-12 lg:pb-10 xl:pb-10 2xl:pb-15"
      contentClassName="relative z-20 h-full"
      backgroundImage={fintechbg}
      backgroundAlt="Fintech background"
    >
      <div className="relative z-10 h-full">
        <Header />

        <div className="absolute bottom-0 left-1/2 w-[90%] -translate-x-1/2 text-center md:bottom-5 lg:bottom-0 xl:bottom-0 2xl:bottom-16">
          <h1 className="font-rajdhani text-2xl md:text-4xl lg:text-5xl xl:text-5xl 2xl:text-7xl font-bold text-white  max-w-full md:max-w-full lg:max-w-[80%] xl:max-w-[70%] 2xl:max-w-[70%] mx-auto">
            {heading}
          </h1>
        </div>
      </div>
    </CommonHeroSection>
  )
}

export default FintechHeroSection
